import React from 'react';
import './TeamCounts.styl';

export default class TeamsCounts extends React.PureComponent {
  render() {
    return (
      <div className="team-counts">
        <div className="count-item">
          Departments: <strong>{this.props.departmentCount}</strong>
        </div>
        <div className="count-item">
          Teams: <strong>{this.props.teamCount}</strong>
        </div>
        <div className="count-item">
          Total active users: <strong>{this.props.userCount}</strong>
        </div>
      </div>
    );
  }
}
